import { useEffect, useState } from 'react';
import { AuthStateType, useAuth } from '../hooks/useAuth';
import { setSentryUser } from '../sentry';

interface AuthInitializerProps {
  children: React.ReactNode;
}

export function AuthInitializer({ children }: AuthInitializerProps) {
  const [authState] = useAuth();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (
      authState.type === AuthStateType.Authenticated ||
      authState.type === AuthStateType.NoToken
    ) {
      setIsInitialized(true);
    }
  }, [authState.type]);

  useEffect(() => {
    if (authState.type === AuthStateType.Authenticated && authState.user) {
      setSentryUser({
        id: authState.user.id,
        email: authState.user.email,
      });
    } else {
      setSentryUser(null);
    }
  }, [authState]);

  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-950">
        <div className="animate-spin rounded-full size-12 border-b-2 border-white"></div>
      </div>
    );
  }

  return <>{children}</>;
}
